import { ReactNode } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import EmailConfirmWrapper from './components/EmailConfirmWrapper'
import JobDetail from './components/JobDetail'
import Layout from './components/Layout'
import Login from './components/Login'
import MainContent from './components/MainContent'
import Onboarding from './components/Onboarding'
import Profile from './components/Profile'
import RequireAuth from './components/RequireAuth'
import ResumeDetail from './components/ResumeDetail'
import ResumesList from './components/ResumesList'
import SearchQueries from './components/SearchQueries'
import Settings from './components/Settings'
import SignupSuccess from './components/SignupSuccess'
import UpdatePassword from './components/UpdatePassword'
import AtsPlayground from './pages/AtsPlayground'
import AuthCallback from './pages/AuthCallback'
import PrepareApplication from './pages/PrepareApplication'
import PostHogPageViewTracker from './components/PostHogPageViewTracker'
import { isResumeOnlyMode } from './lib/resumeOnlyMode'

function ResumeOnlyGuard({ children }: { children: ReactNode }) {
  if (isResumeOnlyMode()) return <Navigate to="/resumes" replace />
  return <>{children}</>
}

function App() {
  return (
    <>
    <PostHogPageViewTracker />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/confirm" element={<EmailConfirmWrapper />} />
      <Route path="/auth/signup-success" element={<SignupSuccess />} />
      <Route path="/auth/update-password" element={<UpdatePassword />} />
      <Route
        path="/onboarding/step-1"
        element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        }
      />
      <Route
        path="/onboarding/step-2"
        element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        }
      />
      <Route
        path="/onboarding/step-3"
        element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        }
      />
      <Route
        path="/onboarding"
        element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        }
      />
      <Route
        path="/"
        element={
          <RequireAuth>
            <ResumeOnlyGuard>
              <Layout>
                <MainContent />
              </Layout>
            </ResumeOnlyGuard>
          </RequireAuth>
        }
      />
      <Route
        path="/job/:id"
        element={
          <RequireAuth>
            <ResumeOnlyGuard>
              <Layout>
                <JobDetail />
              </Layout>
            </ResumeOnlyGuard>
          </RequireAuth>
        }
      />
      <Route
        path="/settings"
        element={
          <RequireAuth>
            <ResumeOnlyGuard>
              <Layout>
                <Settings />
              </Layout>
            </ResumeOnlyGuard>
          </RequireAuth>
        }
      />
      <Route
        path="/search-queries"
        element={
          <RequireAuth>
            <ResumeOnlyGuard>
              <Layout>
                <SearchQueries />
              </Layout>
            </ResumeOnlyGuard>
          </RequireAuth>
        }
      />
      <Route
        path="/resumes"
        element={
          <RequireAuth>
            <Layout>
              <ResumesList />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/resume/:id"
        element={
          <RequireAuth>
            <Layout>
              <ResumeDetail />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/ats-playground"
        element={
          <RequireAuth>
            <ResumeOnlyGuard>
              <Layout>
                <AtsPlayground />
              </Layout>
            </ResumeOnlyGuard>
          </RequireAuth>
        }
      />
      <Route
        path="/prepare/:jobId"
        element={
          <RequireAuth>
            <ResumeOnlyGuard>
              <Layout>
                <PrepareApplication />
              </Layout>
            </ResumeOnlyGuard>
          </RequireAuth>
        }
      />
      <Route
        path="/prepare"
        element={
          <RequireAuth>
            <ResumeOnlyGuard>
              <Layout>
                <PrepareApplication />
              </Layout>
            </ResumeOnlyGuard>
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <Layout>
              <Profile />
            </Layout>
          </RequireAuth>
        }
      />
      {isResumeOnlyMode() && (
        <Route path="*" element={<Navigate to="/resumes" replace />} />
      )}
    </Routes>
    </>
  )
}

export default App
